<template>
  <v-card class="rounded-card"
          outlined>
    <div v-if="!comprador">
      <v-card-text class="text-center">
        Selecione uma <strong>empresa compradora</strong> para carregar as notificações
      </v-card-text>
    </div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && comprador">
      <px-lista-notificacoes is-notificacao-comprador
                             show-dias-limite
                             :notificacoes="notificacoes"
                             @update="getNotificacoes"/>
    </div>
  </v-card>
</template>
<script>
import ListaNotificacoes from './ListaNotificacoes.vue';
import { buildNotificacoes } from '../utils/notificacao-utils';
import NotificacoesService from '../service/config-notificacao-service';

export default {
  props: {
    comprador: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      notificacoes: [],
      loading: false,
    };
  },
  methods: {
    getNotificacoes() {
      this.loading = true;
      NotificacoesService.getNotificacoesCompradorList({
        query: `comprador.id = ${this.comprador.id}`,
      }).then((response) => {
        this.notificacoes = buildNotificacoes(response.data, this.comprador, 'comprador');
      })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    comprador() {
      if (!this.comprador) {
        return;
      }
      this.getNotificacoes();
    },
  },
  components: {
    pxListaNotificacoes: ListaNotificacoes,
  },
};
</script>
